<template>
    <div class="o-container o-container--thin">
        <reset-password-form
            :submit="resetPassword"
            :email="email"
        />
    </div>
</template>

<script>
    import ResetPasswordForm from '../forms/ResetPasswordForm.vue';
    import CreatePasswordForm from '../forms/CreatePasswordForm.vue';
    import '../../store/modules/session/session';

    export default {
        components: {
            ResetPasswordForm,
            CreatePasswordForm
        },
        data() {
          return {
              email: this.$session.has('email') ? this.$session.get('email') : ''
          }
        },
        methods: {
            resetPassword(data) {
                return this.$store.dispatch('user/RESET_PASSWORD', data).then(() => {
                    this.$router.push({
                        name: 'createPassword'
                    });
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
